<script>
const Dialog = window.ELEMENT.Dialog;

export default {
    name: 'MixDialog',
    extends: Dialog,
    props: {
        closeOnClickModal: {
            type: Boolean,
            default: true,
        },
        confirmMsg: {
            type: String,
            default: '关闭后您未提交的内容将丢失，确定关闭？',
        },
    },
    provide () {
        return {
            AonahDialog: this,
        };
    },
    data () {
        return {
            confirmClose: false, // 点遮罩层是否弹出提示框
            unWatch: [],
            dialogMousedown: false,
        };
    },
    mounted () {
        let self = this;
        self.$on('reset-confirm', () => {
            self.unWatch.forEach(f => f.remove());
            self.unWatch = [];
            self.confirmClose = false;
        });
        self.$on('use-confirm', () => {
            self.confirmClose = true;
        });
        self.$el.addEventListener('mousedown', function (e) {
            if (e.path.some(el => {
                return Array.from(el.classList || []).includes('el-dialog');
            })) {
                self.dialogMousedown = true;
            }
        }, true);
        self.$el.addEventListener('mouseup', function (e) {
            if (e.path.some(el => {
                return Array.from(el.classList || []).includes('el-dialog');
            })) {
                self.dialogMousedown = false;
            }
        }, true);
    },
    methods: {
        willClose () {
            this.$emit('reset-confirm');
            return true;
        },
        /* 点击遮罩层 */
        handleWrapperClick () {
            if (!this.closeOnClickModal || this.dialogMousedown) {
                this.dialogMousedown = false;
                return;
            };
            if (this.confirmClose) {
                this.$confirm(this.confirmMsg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.handleClose();
                }).catch(() => {
                });
                return;
            }
            this.handleClose();
        },
        /* 移除watch */
        removeConfirm (val) {
            let idx = this.unWatch.findIndex(m => {
                let x = val,
                    y = m.prop;
                if (typeof val === 'function') {
                    x = val();
                }
                if (typeof y === 'function') {
                    y = y();
                }
                return x === y;
            });
            if (idx !== -1) {
                this.unWatch[idx].remove();
                this.unWatch.splice(idx, 1);
            }
        },
        /* 添加watch */
        watchConfirm (val) {
            this.confirmClose = false;
            this.removeConfirm(val);
            let value = null,
                obj = {
                    prop: val,
                    remove: this.$watch(function () {
                        if (typeof val === 'function') {
                            value = val();
                            obj && (obj.value = value);
                            return val();
                        }
                        value = val;
                        obj && (obj.value = val);
                        return val;
                    }, () => {
                        if (!this.confirmClose) {
                            this.$emit('use-confirm');
                        }
                    }, {
                        deep: true,
                    }),
                    value: '',
                };
            obj.value = value;
            this.unWatch.push(obj);
        },
    },
};
</script>
